import { Box, Container, Divider, useTheme } from '@mui/material';
import AboutInstructorSection from './components/AboutInstructorSection';
import AiHighlightSection from './components/AiHighlightSection';
import CertificationSection from './components/CertificationSection';
import CtaSection from './components/CtaSection';
import HeroSection from './components/HeroSection';
import PlatformFeaturesSection from './components/PlatformFeaturesSection';
import SocialProofSection from './components/SocialProofSection';
import WhatsIncludedSection from './components/WhatsIncludedSection';
import WhatWeDoSection from './components/WhatWeDoSection';
import WhyChooseUsSection from './components/WhyChooseUsSection';

/**
 * The light background color for the hero section
 */
export const HeroLightBgColor = '#f3f3f3';

/**
 * The dark background color for the hero section
 */
export const HeroDarkBgColor = '#151b20';

/**
 * The font size to use for titles
 */
export const SectionTitleFontSize = '3em';

/**
 * The home view of S3G
 */
const HomeView = () => {
  const theme = useTheme();

  return (
    <Box width="100%">
      <Box
        sx={{
          backgroundColor: (t) =>
            t.palette.mode == 'dark' ? HeroDarkBgColor : HeroLightBgColor,
        }}
      >
        <Container maxWidth="lg">
          <HeroSection />
        </Container>
        {/* This box provides the curve on below the hero */}
        <Box
          component="svg"
          preserveAspectRatio="none"
          xmlns="http://www.w3.org/2000/svg"
          x="0px"
          y="0px"
          viewBox="0 0 1920 100.1"
          sx={{
            width: '100%',
            marginBottom: (t) => t.spacing(-1),
          }}
        >
          <path
            fill={theme.palette.background.default}
            d="M0,0c0,0,934.4,93.4,1920,0v100.1H0L0,0z"
          ></path>
        </Box>
      </Box>
      <WhatWeDoSection />
      <Container maxWidth="lg">
        <Divider />
      </Container>
      <WhatsIncludedSection />
      <Container maxWidth="lg">
        <Divider />
      </Container>
      <CertificationSection />
      <WhyChooseUsSection />
      <PlatformFeaturesSection />
      <SocialProofSection />
      <AboutInstructorSection />
      <AiHighlightSection />
      <CtaSection />
    </Box>
  );
};

export default HomeView;
